import {
  ACTIVITIES_BASE_HEIGHT_SMALL,
  SUGGESTED_ANSWER_EXAMPLE,
  SUGGESTED_ANSWER_VARY,
} from 'global/constants';
import { Box } from 'approot/shared/design-system/box/box.style';
import { BadgeSmallStyled } from 'approot/shared/badge/badge.style';
import { ComponentDiscussion } from 'approot/activity-builder/components/component.constants';
import { useGetRichtextAnswer } from 'approot/activity-builder/components/suggested-answers/suggested-answer.hooks';
import { getAnswerTypeLabel } from 'approot/activity-builder/components/suggested-answers/logic/get-answer-type-label';
import { ResponseFieldReadonly } from 'approot/activity-builder/components/response/response-field-readonly.style';
import { getRichtextValue } from 'approot/activity-builder/components/shared/logic/get-richtext-value';
import { SUGGESTED_ANSWER_BASE_RICHTEXT } from 'approot/activity-builder/components/suggested-answers/suggested-answer.constants';
import DiscussionViewQuestion from 'approot/activity-builder/components/discussion/discussion-view-question';
import { ClassroomSuggestedAnswer } from '../classroom-answer.style';
import { DiscussionQuestionOverride } from 'approot/activity-builder/components/discussion/discussion-view-question.style';

type Props = {
  component: Omit<ComponentDiscussion, '__typename'>;
};

const DiscussionResponseSuggestedAnswers = ({
  component: { id, type, properties, suggestedAnswerProperties },
}: Props) => {
  const answerType =
    suggestedAnswerProperties?.suggestedAnswerType || SUGGESTED_ANSWER_EXAMPLE;

  const richtextAnswer = useGetRichtextAnswer({
    componentId: id,
    suggestedAnswerProperties,
  });

  return (
    <>
      <Box $marginBottom={24}>
        <DiscussionQuestionOverride>
          <DiscussionViewQuestion
            id={id}
            type={type}
            discussion={properties.discussion}
            style={properties.style}
          />
        </DiscussionQuestionOverride>
      </Box>
      {answerType === SUGGESTED_ANSWER_VARY ? (
        <ClassroomSuggestedAnswer>
          <ResponseFieldReadonly
            $numberOflines={3}
            $baseHeight={ACTIVITIES_BASE_HEIGHT_SMALL}
          />
          <BadgeSmallStyled>{getAnswerTypeLabel(answerType)}</BadgeSmallStyled>
        </ClassroomSuggestedAnswer>
      ) : (
        richtextAnswer && (
          <ClassroomSuggestedAnswer>
            <ResponseFieldReadonly
              $numberOflines={1}
              $baseHeight={ACTIVITIES_BASE_HEIGHT_SMALL}
              dangerouslySetInnerHTML={{
                __html: getRichtextValue(
                  richtextAnswer,
                  SUGGESTED_ANSWER_BASE_RICHTEXT
                ),
              }}
            />
            <BadgeSmallStyled>
              {getAnswerTypeLabel(answerType)}
            </BadgeSmallStyled>
          </ClassroomSuggestedAnswer>
        )
      )}
    </>
  );
};

export default DiscussionResponseSuggestedAnswers;
